import { render, staticRenderFns } from "./ElevatedBlockBtn.vue?vue&type=template&id=3fdc6ff6"
import script from "./ElevatedBlockBtn.vue?vue&type=script&lang=ts"
export * from "./ElevatedBlockBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports